module.exports = new __parcel__URL__("cookie.099bb841.svg").toString();